/* Kargo günü cümlesi, tek kaynak (sop/urun.json 15; kararlar.md §13). snippets/kuk-kargo-gunu.liquid'in bastığı
   [data-kuk-kargo-gunu] öğelerini Türkiye saatine (Europe/Istanbul) göre yazar, 60 sn'de bir yeniler.
   Kural: kargo günü kesimden önce 'Bugün kargoda'; kargo gününde kesimden sonra ve sonraki kargo günü yarınsa
   'Yarın kargoda'; Cuma kesimden sonra, Cumartesi ve Pazar 'Pazartesi kargoda'. Tatil kargo günü sayılmaz;
   sonraki kargo günü yarınsa 'Yarın kargoda', değilse günün adı. Yarım gün tatilde kesim saati o günün saatidir.
   JS çalışmazsa Liquid'in bastığı 'En geç ertesi iş günü kargoda' kalır; gönderim durdurulduysa dokunulmaz. */
(() => {
  if (window.kukKargoGunu) return;

  // Gün adı ya da kısaltması → 0 (Pazar) ... 6 (Cumartesi); 'Pazartesi' ve 'Cumartesi' önce denenir
  const gunNo = (ad) => {
    const s = String(ad).trim().toLocaleLowerCase('tr');
    if (!s) return undefined;
    if (s.startsWith('pazartesi') || s === 'pzt' || s === 'pts') return 1;
    if (s.startsWith('cumartesi') || s === 'cmt' || s === 'cts') return 6;
    const kisa = { paz: 0, sal: 2, çar: 3, car: 3, per: 4, cum: 5 }[s.slice(0, 3)];
    return kisa;
  };

  // 'Pzt-Cum' ya da 'Pzt,Sal,Çar' → {1,2,3,4,5}
  const gunleriCoz = (metin) => {
    const kume = new Set();
    String(metin || 'Pzt-Cum').split(',').forEach((parca) => {
      const [bas, son] = parca.split('-').map(gunNo);
      if (bas === undefined) return;
      if (son === undefined) { kume.add(bas); return; }
      for (let g = bas; ; g = (g + 1) % 7) { kume.add(g); if (g === son) break; }
    });
    return kume.size ? kume : new Set([1, 2, 3, 4, 5]);
  };

  const dakika = (saat) => {
    const [s, d] = String(saat || '11:00').split(':').map(Number);
    return (Number.isFinite(s) ? s : 11) * 60 + (Number.isFinite(d) ? d : 0);
  };

  // Tatil listesi: ["2026-10-29", {"tarih": "2026-10-28", "kesim": "10:00"}]
  const tatilleriCoz = (metin) => {
    const tam = new Set();
    const yarim = new Map();
    try {
      JSON.parse(metin || '[]').forEach((t) => {
        if (typeof t === 'string') tam.add(t);
        else if (t && t.tarih) { if (t.kesim) yarim.set(t.tarih, dakika(t.kesim)); else tam.add(t.tarih); }
      });
    } catch (hata) { /* bozuk liste: tatil yok sayılır */ }
    return { tam, yarim };
  };

  const istanbul = () => {
    const parcalar = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23',
    }).formatToParts(new Date()).map((p) => [p.type, p.value]));
    const gun = new Date(Date.UTC(+parcalar.year, +parcalar.month - 1, +parcalar.day));
    return { gun, dk: +parcalar.hour * 60 + +parcalar.minute };
  };
  const anahtar = (t) => t.toISOString().slice(0, 10);
  const ekle = (t, n) => new Date(t.getTime() + n * 86400000);

  const cumle = (el) => {
    const gunler = gunleriCoz(el.dataset.gunler);
    const { tam, yarim } = tatilleriCoz(el.dataset.tatil);
    const kesim = dakika(el.dataset.kesim);
    const adlar = String(el.dataset.gunAdlari || 'Pazar,Pazartesi,Salı,Çarşamba,Perşembe,Cuma,Cumartesi').split(',');
    const kargoGunu = (t) => gunler.has(t.getUTCDay()) && !tam.has(anahtar(t));
    const { gun: bugun, dk } = istanbul();
    const bugunKesim = yarim.has(anahtar(bugun)) ? yarim.get(anahtar(bugun)) : kesim;
    if (kargoGunu(bugun) && dk < bugunKesim) return el.dataset.bugun;
    for (let n = 1; n <= 30; n += 1) {
      const t = ekle(bugun, n);
      if (!kargoGunu(t)) continue;
      // Hafta sonu (takvimde kargo günü olmayan gün) sonraki günün adını söyler: Pazar → 'Pazartesi kargoda'
      if (n === 1 && gunler.has(bugun.getUTCDay())) return el.dataset.yarin;
      return String(el.dataset.gun).replace('[gun]', adlar[t.getUTCDay()]);
    }
    return null;
  };

  const yaz = () => {
    document.querySelectorAll('[data-kuk-kargo-gunu]:not([data-durdu])').forEach((el) => {
      const metin = cumle(el);
      if (metin && el.textContent !== metin) el.textContent = metin;
    });
  };

  window.kukKargoGunu = { yaz, cumle };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', yaz);
  else yaz();
  setInterval(yaz, 60000);
})();
